import { faPlusCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import { Config } from '../../../../../shared/config';
import { onSelectUserViewAction } from '../../../../../stores/actions/userData';
import ViewCell from '../../../../Common/Table/ViewCell';
import './../../../modelListStyle.scss';
import modelService from './../../../modelService';

class SftpUserlist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usersData: [],
            noRecordsMessage: null,
            showPagination: false,
        };
        this.modelService = new modelService();
        this.tableList = React.createRef();
    }

    /**
     * Rendering ui elements
     */
    render() {
        const { usersData, noRecordsMessage, showPagination } = this.state;
        return (
            <div className="model-list-box">
                <div>
                    <Button className="add-whitelist-usr-btn text-center btn-sm" onClick={this.addNewUser}>
                        <FontAwesomeIcon className="btn-icon" icon={faPlusCircle} />
                        <span className="ml-2">Add User</span>
                    </Button>
                </div>
                <div className="table-responsive-cm user-list-table sftp-user-list-table" ref={this.tableList}>
                    <ReactTable
                        filterable
                        defaultFilterMethod={(filter, row) =>
                            row[filter.id] !== undefined
                                ? String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                                : false
                        }
                        columns={[
                            {
                                Header: 'Customer Name',
                                accessor: 'company',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: 'Email Address',
                                accessor: 'emailAddress',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            
                            {
                                Header: 'Last Name',
                                accessor: 'lastName',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: 'First Name',
                                accessor: 'firstName',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: 'Role',
                                accessor: 'userRole',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: 'Status',
                                accessor: 'status',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                id: 'sftpEnabled',
                                Header: 'SFTP Enabled',
                                accessor:  d => { return d.sftpEnabled === 0 ? 'NO' : 'YES' },
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: 'Modified Date',
                                accessor: 'modifiedDate',
                                Cell: (props) => {
                                    const modifiedDate = props.value
                                        ? moment.utc(props.value, Config.UI_TIMESTAMP_FORMAT).local()
                                        : '';
                                    return props.value
                                        ? moment(modifiedDate, Config.API_TIMESTAMP_FORMAT).format(
                                              Config.UI_TIMESTAMP_FORMAT,
                                          )
                                        : '';
                                },
                                sortMethod: (a, b) => {
                                    var a1 = new Date(a).getTime();
                                    var b1 = new Date(b).getTime();
                                    if (a1 > b1) return 1;
                                    else if (a1 < b1) return -1;
                                    else return 0;
                                },
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: 'Modified By',
                                accessor: 'modifiedBy',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: () => <div style={{ textAlign: 'center' }}>Action</div>,
                                Cell: ViewCell,
                                getProps: (state, rowInfo) => ({
                                    onClick: () => {
                                        this.userListViewClick(rowInfo);
                                    },
                                }),
                                className: 'td-button-outer',
                                minWidth: 110,
                                filterable: false
                            },
                        ]}
                        data={usersData}
                        noDataText={noRecordsMessage}
                        minRows={usersData.length}
                        showPagination={showPagination}
                        pageSize={usersData.length}
                        className="-highlight cursor-pointer w-100"
                        defaultSorted={[{ id: 'modifiedDate', desc: true }]}
                    />
                </div>
            </div>
        );
    }

    /**
     * Component mount method.
     */
    componentDidMount() {
        // Api call to get the user lis
        const {
            customerData: { customerId },
        } = this.props;
        
        this.modelService.getUsersListByCompanyId(customerId).then((res) => {
            if (res && res.status === 'Success' && res.data && res.data.length > 0) {
                let userList = res.data;
                this.setState({
                    usersData: userList,
                    noRecordsMessage: null,
                });
            } else {
                this.setState({
                    usersData: [],
                    noRecordsMessage: '-No Users Found-',
                });
            }
        });
    }

    /**
     * Add new user button click function.
     */
    addNewUser = () => {
        const {
            customerData: { customerId },
        } = this.props;
        this.props.history.push({
            pathname: '/model/admin/sftp/user/',
            customerId: customerId,
        });
    };

    /**
     * View user button click function.
     */
    userListViewClick(rowInfo) {
        const {
            customerData: { customerId },
        } = this.props;
        this.props.setSelectedUser(rowInfo.original);
        this.props.history.push({
            pathname: `/model/admin/sftp/user/${rowInfo.original.userId}`,
            customerId: customerId,
        });
    }
}

const filterRender = (filter, onChange) => {
    return (
        <div style={{position: 'relative', backgroundColor: '#FFFFFF', paddingLeft: '10px'}}>
        <FontAwesomeIcon icon={faSearch}  className='filter-search-icon' />
        <input
        onChange={event => onChange(event.target.value)}
        value={filter ? filter.value : ''}
        style={{
            width: '100%',
            border: '0px'
        }}
        autoComplete='none'
        />
    </div>
    )
}

/**
 * Redux dipatch events method for changing redux state
 */
const MapDispatchToProps = (dispatch) => {
    return {
        setSelectedUser: (params) => dispatch(onSelectUserViewAction(params)),
    };
};

SftpUserlist.propTypes = {
    history: PropTypes.object.isRequired,
    setSelectedUser: PropTypes.func,
    customerData: PropTypes.object,
};

export default withRouter(connect(null, MapDispatchToProps)(SftpUserlist));
